import React, { useEffect, useRef, useState } from "react";
import Preview from "../Preview";
const Youtube = ({ url, autoplay, previewUrl, rawUrl }) => {
  const [showPreview, setshowPreview] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const loadOnce = useRef(false);

  useEffect(() => {
    setshowPreview(!autoplay);
  }, []);

  const callPlayer = (func, args) => {
    var iframes = document && document.getElementsByTagName("iframe");
    for (var i = 0; i < iframes.length; ++i) {
      if (iframes[i]) {
        var src = iframes[i].getAttribute("src");
        if (src) {
          if (src.indexOf(url) != -1) {
            iframes[i].contentWindow?.postMessage(
              JSON.stringify({
                event: "command",
                func: func,
                args: args || [],
              }),
              "*"
            );
          }
        }
      }
    }
  };

  const playVideo = () => {
    callPlayer("playVideo", []);
  };

  const stopVideo = () => {
    callPlayer("pauseVideo", []);
  };

  const playVedio = () => {
    setshowPreview(false);
    if (iframeRef.current?.src) {
      iframeRef.current.src = rawUrl + "&autoplay=1&mute=0";
    }
  };
  return (
    <div className="video-wrapper">
      <div
        className="full-width"
        style={{ display: showPreview ? "block" : "none" }}
      >
        <Preview url={previewUrl} playVedio={playVedio} />
      </div>

      <iframe
        ref={iframeRef}
        data-ot-ignore
        id="myiframe"
        title="iframe"
        style={{
          display: showPreview ? "none" : "block",
          height: showPreview ? "0" : "100vh",
          minHeight: showPreview ? "0" : "100vh",
        }}
        allowFullScreen
        allow="autoplay"
        onLoad={() => {
          if (autoplay && !loadOnce.current) {
            loadOnce.current = true;
          }
        }}
        src={autoplay ? url : ""}
        className="optanon-category-VID1 full-width"
      ></iframe>
    </div>
  );
};

export default Youtube;
